"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var __1 = require("..");
var Modal = react_1.forwardRef(function Modal(_a, ref) {
    var outerOpen = _a.open, className = _a.className, _b = _a.withCloseButton, withCloseButton = _b === void 0 ? false : _b, children = _a.children, onClose = _a.onClose, rest = __rest(_a, ["open", "className", "withCloseButton", "children", "onClose"]);
    var classes = useStyles();
    var _c = react_1.useState(outerOpen), open = _c[0], setOpen = _c[1];
    react_1.useEffect(function () {
        setOpen(outerOpen);
    }, [outerOpen]);
    var handleClose = function (event, reason) {
        if (onClose) {
            onClose === null || onClose === void 0 ? void 0 : onClose(event, reason);
        }
        else {
            setOpen(false);
        }
    };
    var handleCloseClick = function (event) {
        if (onClose) {
            onClose === null || onClose === void 0 ? void 0 : onClose(event, 'closeButtonClicked');
        }
        else {
            setOpen(false);
        }
    };
    return (jsx_runtime_1.jsx(core_1.Modal, __assign({ ref: ref, onClose: handleClose, open: open }, rest, { className: classes.modal }, { children: jsx_runtime_1.jsx(__1.Slide, __assign({ in: open }, { children: jsx_runtime_1.jsx("div", __assign({ className: className }, { children: jsx_runtime_1.jsxs("div", __assign({ className: classes.wrapper }, { children: [withCloseButton && (jsx_runtime_1.jsx(__1.IconButton, __assign({ className: classes.close, size: "small", onClick: handleCloseClick, color: "inherit" }, { children: jsx_runtime_1.jsx(__1.Icon.Close, {}, void 0) }), void 0)), children] }), void 0) }), void 0) }), void 0) }), void 0));
});
exports.default = Modal;
var useStyles = core_1.makeStyles(function (theme) { return ({
    modal: {
        outline: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& div,& video,& img': {
            outline: 'none',
        },
    },
    wrapper: {
        outline: 'none',
        position: 'relative',
        '& > img': {
            maxWidth: '100%',
        },
    },
    close: {
        position: 'absolute',
        background: theme.palette.primary.main,
        color: '#fff',
        top: '0',
        right: '0',
        transform: 'translate3D(50%,-50%,0)',
        '&:hover': {
            background: theme.palette.primary.light,
        },
    },
}); });
//# sourceMappingURL=Modal.js.map